import { ErrorHandler, MetaHandler, UpdateHandler } from "./types";

export class StreamClient<TData> {
  public id: string;
  updateCb: UpdateHandler<TData>;
  errorCb: ErrorHandler;
  metaCb?: MetaHandler;
  constructor(
    onUpdate: UpdateHandler<TData>,
    onError: ErrorHandler,
    onMeta?: MetaHandler
  ) {
    this.id = crypto.randomUUID();
    this.updateCb = onUpdate;
    this.errorCb = onError;
    this.metaCb = onMeta;
  }
}
